'use strict';

import './styles/front.scss';
import {DonorList} from "./scripts/components/DonorList.js";
import {P2PCampaignGallery} from './scripts/components/P2PCampaignGallery.js'
import {MyAccountP2PCampaigns} from "./scripts/components/MyAccountP2PCampaigns.js";
import {P2PCampaigns} from "./scripts/P2PCampaigns.js";
import {SignUp} from "./scripts/SignUp.js";

document.addEventListener( 'DOMContentLoaded', async () => {
	new DonorList().watchPagination();
	new P2PCampaignGallery();
	new SignUp();
	new P2PCampaigns().disableCustomP2PGoalRequireAttribute();
	if (document.body.classList.contains('woocommerce-account')) {
		new MyAccountP2PCampaigns();
	}
});
